import { useContext } from "react";
import { FilterDataStateContext } from "../context-providers/FilterDataStateProvider";

export const useFilterData = () => useContext(FilterDataStateContext);
